import { LogonService } from '@sabstravtech/obtservices/angular';
import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService, User } from '@auth0/auth0-angular';
import { firstValueFrom } from 'rxjs';
import { Location } from '@angular/common';

const GUARD_EXCEPTIONS = [
  // list of exceptions to the guard - anyone can get to these pages, even if not logged in
  '/sso',
  '/login',
  '/auth/auth0',
  '/sso-logout'
];

const sso_re = /^\/sso\/(?:flight|hotel|rail)/;
const sso_code = /access_token=/;

@Injectable({ providedIn: 'root' })
export class AuthGuard {
  private tokenPromise: Promise<[string, User]> | null = null; // To store the pending promise
  constructor(
    private authService: LogonService,
    private router: Router
    // private auth0: AuthService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const url: string = state.url;
    return this.checkLogin(url);
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return this.canActivate(route, state);
  }

  async checkLogin(url: string): Promise<boolean> {
    if (
      GUARD_EXCEPTIONS.includes(url) ||
      sso_re.test(url) ||
      (await this.authService.checkLogin())
    ) {
      return true;
    }
    this.authService.redirectUrl = url;

    if (!GUARD_EXCEPTIONS.includes(this.router.url)) {
      this.router.navigate(['/logon']);
    }
    return false;
  }
}
